// src/context/TimeContext.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const TimeContext = createContext({ tick: 0 });

export function TimeProvider({ children, intervalMs = 60_000 }) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  const value = useMemo(() => ({ tick }), [tick]);

  return <TimeContext.Provider value={value}>{children}</TimeContext.Provider>;
}

export function useTimeTick() {
  return useContext(TimeContext).tick;
}
